import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from 'src/app/common/services/api.service';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { MessageService } from 'src/app/common/services/message.service';

@Component({
  selector: 'app-publish-modal',
  templateUrl: './publish-modal.component.html',
  styleUrls: ['./publish-modal.component.css']
})
export class PublishModalComponent implements OnInit {
  isLoading:boolean=false
  publishData:any;
  showLoader:boolean = true;
  constructor(
    private modalRef: NzModalRef,
    private apiService: ApiService,
    private message: MessageService,
    private _localStorage: LocalStorageService,
    private cdr: ChangeDetectorRef,
    ) {
    }

  ngOnInit() {
    this.getGrabChanges();
  }

  getGrabChanges(){
    this.publishData = {};
    this.showLoader = true;
    this.apiService.getGrabChangesData(this._localStorage.get('restaurant_id')).subscribe(
      (res) => {
        this.showLoader = false;
        if((res || {}).statusCode === 200){
         this.publishData = (res || {})
         if(this.publishData && this.publishData.items){
           this.publishData.items.forEach((el)=>{
             let messageStr='';
             if(el.message && Array.isArray(el.message )){
                for(let i=0;i<el.message.length;i++){
                   if(i!=0){messageStr=messageStr+" , "}
                   messageStr=messageStr+el.message[i];
                }
               el.message= messageStr;
           }
           });
         }
         this.cdr.detectChanges();
      }
        else{
          this.message.showError(res.message || {})
        }
      },
      (error) => {
        this.showLoader = false;
        this.message.showError(error.message || {})
      }
    );
  }

  changesSync(){
    this.isLoading = true
    let param = {
      restaurant_id : this._localStorage.get('restaurant_id')
    }
    this.apiService.grabChangesSync(param).subscribe(
      (res) => {
        this.isLoading = false
        if((res || {}).statusCode === 201){
         this.dismissModal('success')
        }
        else{
          this.message.showError(res.message || {})
          this.dismissModal()
        }
      },
      (error) => {
        this.message.showError((error.error || {}).message)
        this.isLoading = false
        this.dismissModal()
      }
    );
  }
  dismissModal(data?) {
    this.modalRef.close(data);
  }
}
